import { render } from "./radio-button.component.vue?vue&type=template&id=7a533a36&scoped=true&ts=true"
import script from "./radio-button.component.vue?vue&type=script&lang=ts"
export * from "./radio-button.component.vue?vue&type=script&lang=ts"

import "./radio-button.component.vue?vue&type=style&index=0&id=7a533a36&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a533a36"]])

export default __exports__